module.exports = __webpack_public_path__ + "img/h-1m.e32102d2.jpg";